import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col } from '../../../packages/kiti/components/structure/Grid'
import { useOpenCreateTemplateRecordModal } from '../../../utils/routes/modals/modalsActions'
import { usePermalinkNavigation } from '../../../utils/routes/permalinkNavigation'
import { useServiceOrder } from './_load/ServiceOrderLoader'
import { useSubdomain } from '../../../utils/contexts/UrlProvider'
import FlexGrid from '../../../components/structure/FlexGrid'
import IconButton from '../../../components/actions/IconButton'

const ControlBar = () => {
  const { t } = useTranslation('serviceOrders')
  const ws = useSubdomain()
  const serviceOrder = useServiceOrder()
  const canCreateTemplateRecord = useSessionPermission('createTemplateRecord')
  const openCreateTemplateRecordModal = useOpenCreateTemplateRecordModal()
  const navigate = usePermalinkNavigation()

  const generatePDF = () => {
    if (ws === 'srsms') {
      navigate(`/pdfs/1/srsms/relatorio/${serviceOrder.id}`)
    } else {
      navigate(`/service-orders/${serviceOrder.id}/pdf`)
    }
  }

  return (
    <FlexGrid justify="space-between" gutter={0.2}>
      <Col flex={1} />

      {canCreateTemplateRecord && (
        <IconButton
          icon="BsFileRichtext"
          onClick={() =>
            openCreateTemplateRecordModal({
              entity: 'service_order',
              recordId: serviceOrder.id,
              checklistIds: serviceOrder?.checklistId || serviceOrder?.checklist?.id
            })
          }
          transparent
          label={t('resume.generateCustomDocument')}
        />
      )}

      <IconButton icon="BsFileRichtext" onClick={generatePDF} transparent label={t('resume.generatePDF')} />
    </FlexGrid>
  )
}

export default ControlBar
